import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './datasetDetail.module.scss';
import { DataProduct } from 'v2/models';
import Avatar from 'v2/Avatar/Avatar';
import avatarPersonNoProfilePic from 'v2/images/avatarPersonNoProfilePic.png';
import { FormGroup } from 'react-bootstrap';
import SectionHeader from 'v2/common/DRM/SectionHeader/SectionHeader';
import HtmlRenderer from 'v2/common/HtmlRenderer/HtmlRenderer';
import { Link } from 'react-router-dom';
import DataProductsDetail from 'v2/pages/DataVendorDetails/DataProductsTab/DataProductDetail';
import EditDatasetDescriptionModal from 'v2/common/DRM/DataProduct/Modals/EditDescriptionModal/EditDescriptionModal';
import { NoDataContent } from 'v2/common/DRM/DataProduct/DataProductDetailTab/DataProductDetailTab';
import DataSetActions from 'v2/common/DRM/DataProduct/DataSetActions/DataSetActions';
import useHistoryBackState from 'v2/hooks/useHistoryBackState';
import CopyEntityButton from 'v2/common/CopyEntityButton/CopyEntityButton';

interface DatasetDetailProps {
  dataset: DataProduct;
  refetch: () => void;
  className?: string;
}

const DatasetDetail = ({ dataset, className, refetch }: DatasetDetailProps) => {
  const [showEditDescriptionModal, setShowEditDescriptionModal] =
    useState(false);
  const { goBackHistory } = useHistoryBackState('/data-sets/1');

  const handleUpdateDataProduct = () => {
    setShowEditDescriptionModal(false);
    refetch();
  };

  return (
    <>
      <div
        className={classnames(
          'container-xl',
          'h-100',
          styles.datasetDetailsContainer,
          className
        )}
      >
        <div
          className={classnames(
            'pr-4 d-flex fix-bg-images pl-4',
            styles.leftContent
          )}
          data-cy="dataset:detail-left-content"
        >
          <FormGroup>
            <div className="d-flex flex-row">
              {dataset.data_vendor && (
                <Avatar
                  data-cy="datavendor:avatar"
                  url={
                    dataset.data_vendor.avatar_url || avatarPersonNoProfilePic
                  }
                  className={styles.avatar}
                  initials={dataset.data_vendor.name[0]}
                />
              )}

              <div
                className={classnames(
                  'd-flex flex-column',
                  dataset.data_vendor ? 'ml-3' : '',
                  styles.nameContainer
                )}
              >
                {dataset.name && (
                  <label className={styles.name}>
                    {dataset.name} <CopyEntityButton />
                  </label>
                )}
                {dataset.data_vendor?.name && (
                  <Link
                    data-testid={`primary_datavendor`}
                    data-cy="datavendor:name-link"
                    key={dataset.data_vendor.id}
                    to={{
                      pathname: `/data-provider-details/${dataset.data_vendor.id}/detail`,
                      state: {
                        counterToGoBack: -1,
                        backLinkTitle: `${dataset.name}`,
                      },
                    }}
                  >
                    {dataset.data_vendor.name}
                  </Link>
                )}
              </div>
              <div className={classnames(styles.actions)}>
                <DataSetActions
                  dataSet={dataset}
                  onChange={() => refetch()}
                  onDelete={() => goBackHistory()}
                />
              </div>
            </div>
            <div className="d-flex flex-column">
              <SectionHeader
                title="Description"
                isEditable={dataset.is_editable}
                className={styles.description}
                onClick={() => setShowEditDescriptionModal(true)}
              />
              <NoDataContent
                title="the description"
                hasValue={Boolean(dataset.description)}
              >
                <div
                  data-testid={`value_Description`}
                  className={styles.descriptionTexts}
                >
                  <HtmlRenderer source={dataset.description} />
                </div>
              </NoDataContent>
            </div>
          </FormGroup>
        </div>

        <div className={classnames(styles.tabs_container)}>
          <DataProductsDetail
            dataProduct={dataset}
            dataVendor={dataset.data_vendor}
            onUpdate={refetch}
          />
        </div>
      </div>
      <EditDatasetDescriptionModal
        show={showEditDescriptionModal}
        dataProduct={dataset}
        onClose={handleUpdateDataProduct}
      />
    </>
  );
};

export default DatasetDetail;
